var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vqb-rule card"},[_c('member',{attrs:{"member":_vm.member,"vars":_vm.vars,"operator":_vm.operatorText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }